import UserEvent from './UserEvent';

type EventData = {
  isBot: boolean;
  pageType: string;
};

class SizeSelectionEvent extends UserEvent<EventData> {
  collectServerEvents() {
    this.serverEvents.push({
      data: { pageType: this.data.pageType },
      type: 'size_selection'
    });
  }
}

export default SizeSelectionEvent;
